// see: https://github.com/kolodny/redux-standard-action


export const Actions = {
    LOGIN_USER_REQUEST:'LOGIN_USER_REQUEST', // user is asked for credentials : login window is visible
    LOGIN_SERVER_REQUEST:'LOGIN_SERVER_REQUEST', // credentials sent to server: login window shows progress
    LOGIN_SUCCESS:'LOGIN_SUCCESS', // server happy
    LOGIN_FAILURE:'LOGIN_FAILURE', // server not happy
    LOGIN_ABORT:'LOGIN_ABORT', // user changed her mind, not going to work ever again
    LOGOUT_REQUEST:'LOGOUT_REQUEST', // log out
    LOGOUT_SUCCESS:'LOGOUT_SUCCESS', // log out

    // used with defaultAsyncActionFactory - will append _REQUEST, _SUCCESS, _FAILURE
    GET_ITEMS:'GET_ITEMS',
    ITEMS_UPDATED:'ITEMS_UPDATED',
    PATCH_ITEMS:'PATCH_ITEMS',

    // used with defaultAsyncActionFactory - will append _REQUEST, _SUCCESS, _FAILURE
    GET_SEARCH_ITEMS:'GET_SEARCH_ITEMS',

    // used with defaultAsyncActionFactory - will append _REQUEST, _SUCCESS, _FAILURE
    GET_ASSIGNEES:'GET_ASSIGNEES',
    ASSIGNEES_UPDATED:'ASSIGNEES_UPDATED',
    PATCH_ASSIGNEES:'PATCH_ASSIGNEES',

    // used with defaultAsyncActionFactory - will append _REQUEST, _SUCCESS, _FAILURE
    GET_WORK_SESSIONS:'GET_WORK_SESSIONS',

    // used with defaultAsyncActionFactory - will append _REQUEST, _SUCCESS, _FAILURE
    GET_WORK_SESSION_TEMPLATES:'GET_WORK_SESSION_TEMPLATES',

    // used with defaultAsyncActionFactory - will append _REQUEST, _SUCCESS, _FAILURE
    GET_CURRENT_WORK_SESSION:'GET_CURRENT_WORK_SESSION',
    PATCH_WORK_SESSION:'PATCH_WORK_SESSION',

    // used with defaultAsyncActionFactory - will append _REQUEST, _SUCCESS, _FAILURE
    CREATE_NEW_WORK_SESSION:'CREATE_NEW_WORK_SESSION',
    CURRENT_WORK_SESSION_UPDATED:'CURRENT_WORK_SESSION_UPDATED',

    // used with defaultAsyncActionFactory - will append _REQUEST, _SUCCESS, _FAILURE
    GET_ACCOUNT:'GET_ACCOUNT',
    // manually called on successful create work session
    GET_ACCOUNT_SUCCESS:'GET_ACCOUNT_SUCCESS',
    // used with defaultAsyncActionFactory - will append _REQUEST, _SUCCESS, _FAILURE
    GET_GROUPS:'GET_GROUPS',

    CREATE_NEW_WORK_SESSION_REQUEST:'CREATE_NEW_WORK_SESSION_REQUEST',
    CREATE_NEW_WORK_SESSION_SUCCESS:'CREATE_NEW_WORK_SESSION_SUCCESS',
    CREATE_NEW_WORK_SESSION_FAILURE:'CREATE_NEW_WORK_SESSION_FAILURE',

    MUTATION_SAVE:'MUTATION_SAVE',
    MUTATIONS_SAVE:'MUTATIONS_SAVE',
    MUTATIONS_NEUTRALIZE:'MUTATIONS_NEUTRALIZE',
};




// WEBPACK FOOTER //
// ./src/model/constants/actions.js